var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M126.79,64.09c0-2.68-1.67-5.09-4.36-6.28l-18.35-8.14,18.35-8.12c2.7-1.19,4.37-3.6,4.37-6.28,0-2.68-1.67-5.09-4.36-6.28L67.21,4.49c-2.32-1.03-5.1-1.03-7.42,0L4.58,28.95c-2.69,1.19-4.37,3.6-4.37,6.28,0,2.68,1.67,5.09,4.37,6.28l18.35,8.13-18.35,8.13c-2.69,1.19-4.37,3.6-4.37,6.28,0,2.68,1.67,5.09,4.37,6.28l17.09,7.57-17.1,7.58c-2.69,1.19-4.37,3.6-4.37,6.28,0,2.68,1.67,5.09,4.37,6.28l55.21,24.46c1.16.51,2.43.77,3.71.77s2.55-.26,3.71-.77l55.21-24.43c2.7-1.19,4.37-3.6,4.37-6.28,0-2.68-1.67-5.09-4.36-6.28l-17.1-7.59,17.09-7.56c2.7-1.19,4.37-3.6,4.37-6.28ZM12.33,35.23L63.38,12.61c.06-.02.18-.02.24,0l51.05,22.65-21.56,9.54-10.97,4.85-18.52,8.2c-.06.02-.18.02-.24,0l-18.52-8.21-10.96-4.86-21.56-9.55ZM114.67,91.8l-51.04,22.59c-.06.02-.18.02-.24,0l-51.05-22.62,20.31-9,27.15,12.03c1.16.51,2.43.77,3.71.77s2.55-.26,3.71-.77l27.15-12.02,20.31,9.01ZM94.36,73.07l-10.97,4.85-19.77,8.75c-.06.02-.18.02-.24,0l-19.77-8.76-10.96-4.86-20.31-9,21.56-9.56,20.31,9,5.59,2.48c1.16.51,2.43.77,3.71.77s2.55-.26,3.71-.77l5.59-2.47,20.31-8.99,21.57,9.57-20.31,8.99Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.85e4187baac3b4fac3fab68357288b9f.svg";
export { ForwardRef as ReactComponent };